import Product from './Product';

export default class Quickshop {
  constructor() {
    this.el = document.querySelector('[data-quickshop]');
    this.contentEl = document.querySelector('[data-quickshop-content]');
    this.closeEl = document.querySelector('[data-quickshop-close]');
    this.injectEl = this.el.querySelector('[data-quickshop-product-inject]');
    this.settingsSha256 = this.el.getAttribute('data-quickshop-settings-sha256');
    this.useCaching = !(window.Shopify && window.Shopify.designMode);

    this.deferred = {};

    this.onContentClick = this._onContentClick.bind(this);
    this.onCloseClick = this.close.bind(this);
  }

  load(url, productSha256) {
    let data;
    if (url in this.deferred) {
      return this.deferred[url];
    }

    const $deferred = $.Deferred();

    this.deferred[url] = $deferred;

    if (this.useCaching) {
      data = sessionStorage.getItem(url);

      if (data) {
        const deserialized = JSON.parse(data);

        if (
          (productSha256 === deserialized.options.product_sha256)
          && (this.settingsSha256 === deserialized.options.settings_sha256)
        ) {
          delete this.deferred[url];

          return $deferred.resolve(deserialized).promise();
        }
      }
    }

    this.url = url;

    $.ajax({
      url,
      data: 'view=ajax',
      dataType: 'html',
      success: (data) => {
        const el = document.createElement('div');
        el.innerHTML = data;

        const options = JSON.parse(el.querySelector('[data-product-options]').innerHTML);
        const html = el.querySelector('[data-product-html]').innerHTML;

        if (this.useCaching) {
          try {
            sessionStorage.setItem(
              url,
              JSON.stringify({ options, html })
            );
          } catch (error) {}
        }

        delete this.deferred[url];
        return $deferred.resolve({ options, html });
      },
      error: (jqXHR, textStatus, errorThrown) => {
        delete this.deferred[url];
        return $deferred.reject();
      }
      ,
    });

    return $deferred.promise();
  }

  open(url, productSha256) {
    const $deferred = $.Deferred();

    this.el.addEventListener('click', this.onCloseClick);
    this.contentEl.addEventListener('click', this.onContentClick);
    this.closeEl.addEventListener('click', this.onCloseClick);

    this.el.classList.add('quickshop-visible');

    this.load(url, productSha256).done((data) => {
      this.injectEl.innerHTML = data.html;
      this.product = new Product(this.injectEl, data.options);
      this.el.classList.add('quickshop-loaded');

      return $deferred.resolve();
    }).fail($deferred.reject());

    return $deferred.promise();
  }

  close() {
    if (this.product != null) {
      this.product.unload();
    }

    this.el.removeEventListener('click', this.onCloseClick);
    this.contentEl.removeEventListener('click', this.onContentClick);
    this.closeEl.removeEventListener('click', this.onCloseClick);

    this.el.classList.remove('quickshop-loaded');
    return this.el.classList.remove('quickshop-visible');
  }

  unload() {
    return this.close();
  }

  _onContentClick(e) {
    return e.stopPropagation();
  }
}
